<h1 matDialogTitle>
  <ng-container *ngIf="!data.id">New Logistic</ng-container>
  <ng-container *ngIf="data.id">Edit Logistic</ng-container>
</h1>
<mat-dialog-content>

  <aw-logistic-form [logistic]="data" (saved)="dialogRef.close(true)"
    (canceled)="dialogRef.close(false)"></aw-logistic-form>

</mat-dialog-content>